import {capitalize, upperCaseName, filterCountryList} from "../../../../helper/tools";
import useData from "../../../../hooks/useData";
import useAuth from "../../../../hooks/useAuth";
import {getCountryList} from "../../../../api/admin/addressReq";
import { useEffect } from "react";

export default function DeceasedInfos({deceasedInfos}) {
    const { countryList, setCountryList } = useData();
    const { auth } = useAuth();
    const token = auth?.token;

    useEffect(() => {
        const apiCountryList = async () => {
            if (token && (!countryList || countryList.length === 0)) {
                const response = await getCountryList(token);
                setCountryList(response);
            }
        }
        apiCountryList();
    }, [token, countryList, setCountryList]);

    return (
        <div className="deceased-infos-content flex">
            <div className="deceased-infos-column">
                <legend><i className="fa fa-id-card-clip"/>Identité du défunt</legend>
                {!deceasedInfos?.hiddenCivility &&
                    <div>
                        <label>Civilité :</label>
                        <span>{deceasedInfos?.civility === "MME" ? "Madame" : "Monsieur"}</span>
                    </div>
                }
                <div>
                    <label>Prénom :</label>
                    <span>{capitalize(deceasedInfos?.firstName)}</span>
                </div>
                <div>
                    <label>Nom :</label>
                    <span>
                        {upperCaseName(deceasedInfos?.lastName)}
                        {deceasedInfos?.birthName && ` (${deceasedInfos?.civility === "MME" ? "née" : "né"} ${upperCaseName(deceasedInfos.birthName)})`}
                    </span>
                </div>
            </div>
            <div className="deceased-infos-column">
                <legend><i className="fa fa-house"/>Adresse complète</legend>
                <div>
                    <label>Adresse :</label>
                    <span>{deceasedInfos?.actualplace?.address}</span>
                </div>
                <div>
                    <label>Code postal :</label>
                    <span>{deceasedInfos?.actualplace?.zipcode}</span>
                </div>
                <div>
                    <label>Ville :</label>
                    <span>{deceasedInfos?.actualplace?.city}</span>
                </div>
                <div>
                    <label>Pays :</label>
                    <span>{filterCountryList(countryList, deceasedInfos?.actualplace?.country)}</span>
                </div>
            </div>
            <div className="deceased-infos-column">
                <legend><i className="fa fa-calendar"/>Informations de naissance</legend>
                <div>
                    <label>Date de naissance :</label>
                    <span>{deceasedInfos?.formattedBirthDate}</span>
                </div>
                <div>
                    <label>Code postal :</label>
                    <span>{deceasedInfos?.birthplace?.zipcode}</span>
                </div>
                <div>
                    <label>Ville :</label>
                    <span>{deceasedInfos?.birthplace?.city}</span>
                </div>
                <div>
                    <label>Pays :</label>
                    <span>{filterCountryList(countryList, deceasedInfos?.birthplace?.country)}</span>
                </div>
            </div>
            <div className="deceased-infos-column">
                <legend><i className="fa fa-newspaper"/>Informations de décès</legend>
                <div>
                    <label>Date de décès :</label>
                    <span>{deceasedInfos?.formattedDeathDate}</span>
                </div>
                <div>
                    <label>Code postal :</label>
                    <span>{deceasedInfos?.deathplace?.zipcode}</span>
                </div>
                <div>
                    <label>Ville :</label>
                    <span>{deceasedInfos?.deathplace?.city}</span>
                </div>
                <div>
                    <label>Pays :</label>
                    <span>{filterCountryList(countryList, deceasedInfos?.deathplace?.country)}</span>
                </div>
            </div>
        </div>
    )
}